export class PropertySearchRequest {
    constructor(public nameFilter?: any,
                public classes?: string[]) {
    }
}
